export const customerMaturityPolicyLines = [
  { key: 'AUTO', label: '자동차보험', shortLabel: '자동차', aliases: ['AUTO', '자동차', '자동차보험', '차량', '차량보험'] },
  { key: 'GENERAL', label: '일반보험', shortLabel: '일반', aliases: ['GENERAL', '일반', '일반보험'] },
  { key: 'FIRE', label: '화재보험', shortLabel: '화재', aliases: ['FIRE', '화재', '화재보험'] },
  { key: 'DRIVER', label: '운전자보험', shortLabel: '운전자', aliases: ['DRIVER', '운전자', '운전자보험'] },
  { key: 'INDEMNITY', label: '실손보험', shortLabel: '실손', aliases: ['INDEMNITY', '실손', '실손보험', '실비', '실비보험', '의료실비'] },
  { key: 'WHOLE_LIFE', label: '종신보험', shortLabel: '종신', aliases: ['WHOLE_LIFE', 'WHOLELIFE', 'LIFE', '종신', '종신보험'] },
  { key: 'HEALTH', label: '건강보험', shortLabel: '건강', aliases: ['HEALTH', '건강', '건강보험', '질병', '질병보험', '상해', '상해보험'] },
  { key: 'ETC', label: '기타보험', shortLabel: '기타', aliases: ['ETC', '기타', '기타보험'] },
]

export function customerMaturityPolicyLineLabel(value) {
  const raw = String(value || '').trim()
  if (!raw) return '—'
  const normalized = raw.toUpperCase().replace(/[\s_-]+/g, '')
  const line = customerMaturityPolicyLines.find((item) => (
    item.key.replace(/[\s_-]+/g, '') === normalized
    || item.aliases.some((alias) => alias.toUpperCase().replace(/[\s_-]+/g, '') === normalized)
  ))
  return line?.shortLabel || raw
}